/**
 * Create a `function` which loads Schema.org properties from a GraphQL end-point.
 *
 * @since 1.0.0
 * @param {string} url The remote endpoint.
 * @returns {function(*=): Promise<Response | never>}
 * @constructor
 */
const FetchLoader = url => selected =>
  fetch(url, {
    method: "POST",
    body: JSON.stringify({
      query: `query {
	schemaProperties(classes: ${JSON.stringify(selected)} ) {
		name
		label
		description
		weight
        ranges {
            name
            label
        }
	}
}`,
      variables: null
    }),
    headers: { "Content-Type": "application/json; charset=UTF-8" }
  })
    .then(response => response.json())
    .then(json => json["schemaProperties"])
    .then(properties =>
      // Sort alphabetically.
      properties.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) return -1;

        if (nameA > nameB) return 1;

        return 0;
      })
    );

export default FetchLoader;
